import { ContentstackConfig } from './model/ContentstackConfig';
import { ContentstackConfigService } from './service/ContentstackConfigService';

export const contentstackConfig = (): ContentstackConfig => ContentstackConfigService.get();
